import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import type User from '../../api/app/models/user'

export const useAuth = defineStore('auth', () => {
  const api = useApi()
  const jwt = useStorage<string>('access-token', null, localStorage)
  const runtimeConfig = useRuntimeConfig()
  const msAuth = useMSAuth()
  const user = ref<User | null>(null)
  const isAuthenticated = computed(() => jwt.value !== null)
  const localStorageName = useLocalStorage('name', '')

  watch(
    () => user.value?.name,
    () => {
      if (user.value?.name) {
        localStorageName.value = user.value.name
      }
    },
  )

  const fetchUser = async () => {
    const res = await api.users.me()
    user.value = res

    return res
  }

  const logout = async () => {
    jwt.value = null
    user.value = null
    navigateTo('/login')
  }

  return {
    jwt,
    user,
    isAuthenticated,
    onHTTP401: async (error: any) => {
      user.value = null
      jwt.value = null
    },
    logout,
    fetchUser,
    reAuthenticate: async () => {
      if (isAuthenticated.value) {
        try {
          return await fetchUser()
        } catch (e: any) {
          if (e?.response?.status === 401) {
            await logout()
            return null
          }
          throw e
        }
      }
    },
    oauth: {
      emailOtp: {
        isEnabled: async () => {
          const res = await api.integrations.execute(
            'buildinEmailOtp',
            'getPublicConfig',
            {},
          )
          return res.enabled || false
        },
        sendCode: async (email: string) => {
          return api.integrations.execute('buildinEmailOtp', 'sendCode', {
            email,
          })
        },
        consumeCode: async (email: string, code: string) => {
          const res = await api.integrations.execute(
            'buildinEmailOtp',
            'consumeCode',
            { email, code },
          )
          jwt.value = res.accessToken.token
          user.value = res.user
          return res
        },
      },
      microsoft: {
        callback: async (accessToken: string) => {
          const res = await api.integrations.execute(
            'microsoftEntra',
            'callback',
            { accessToken },
          )
          jwt.value = res.accessToken.token
          user.value = res.user
          return res
        },
      },
    },
  }
})
